import React from "react";
import { formatDate } from "../../../helpers/helpers.jsx";
import { CD } from "./CD06.json";
import { text01, text02, postTitle } from "./Post01.json";

const BlogPost = ({ lang }) => {
  return (
    <div className="postContainer">
      <div className="postHeader">
        <h1 className="postTitle">{postTitle[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2017-01-07")}</span>
      </div>
      <div className="postText postText-center">
        <div className="postImageContainer-50">
          <img src="images/CD06.jpg" alt="cd06" />
        </div>
        <p style={{ textAlign: "center" }}>
          {text01[lang]} <b>{CD.title}</b>, {text02[lang]}
        </p>
        <div className="postText postText-left postText-small">
          <table className="postTableAlternate">
            <tbody>
              {CD.tracks.map((track, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>
                    {track.title}, {track.time}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        {CD.info[lang]}
      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post01/Post01.jsx